module.exports = __webpack_public_path__ + "img/tab1.acac0945.png";